var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px"}},[_c('EditForm',{ref:"editForm",attrs:{"disabled":_vm.disabled,"amzFirstDemandCode":_vm.amzFirstDemandCode,"pageType":_vm.pageType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }